export const NOTES_PRIORITY = {
  0: 'Low',
  1: 'Medium',
  2: 'High',
  3: 'Severe',
};
